import { useState } from "react";
import ShowMoreText from "react-show-more-text";

export const AllReviews = () => {

  return (
    <div className="row py-5" id="quote">

      {/* RTO Thane Sanwad */}
      <div className="col-12 col-md-6 col-lg-5 mx-auto ">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3  shadow2 rounded">
          <video width="100%" height="300px" poster="Assets/Images/video/RTOThaneImage.png" controls>
            <source src="Assets/Images/video/RTOThane.mp4" type="video/mp4" />
          </video>
          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" आर.टी.ओ ठाणे संवाद " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              WhatsApp Chatbot (8369532705)
              The RTO Thane Sanwad WhatsApp Chatbot is a citizen-friendly digital assistant designed to help users access Contactless License Services through the Parivahan Sarathi Portal. It provides step-by-step guidance for services such as issuing learner’s licences, duplicate licences, renewal of licences, change of name/address, and hazardous material endorsements. Users can simply send a message on WhatsApp to get assistance with licence number validation, required documents, forms, and fee details, along with instructions for completing the online application process. This makes the system convenient, transparent, and efficient, reducing the need for physical visits to the RTO office.
            </ShowMoreText>
          </p>
          <footer className="blockquote-footer pt-4 mt-3 border-top"><b className="text-dark">RTO Thane</b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> आर.टी.ओ ठाणे संवाद</cite>
          </footer>
        </blockquote>
      </div>


      {/* Zilha Parishad Pune */}
      <div className="col-12 col-md-6 col-lg-5 mx-auto ">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          <video width="100%" height="300px" poster="Assets/Images/video/eSanchitPhoto.png" controls>
            <source src="Assets/Images/video/eSanchit01.mp4" type="video/mp4" />
          </video>

          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" ई - संचित " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              We are pleased to share that the <strong>“e-Sanchit”</strong> project of Zilla Parishad Pune has been successfully inaugurated by Hon. Minister, Maharashtra State. The software has greatly streamlined our processes with its five powerful modules:
              <strong> SOPI </strong> – Ensures that PPO and pension are issued on the very day of retirement.
              <strong> MRMS</strong> – Provides a fully online medical reimbursement system for faster and more transparent claim processing.
              <strong> GPF</strong> – Offers monthly online credit updates with SMS alerts and quick disbursement of funds.
              <strong> GIS</strong> – Enables timely settlement of group insurance benefits for employees.
              Deposit Accounting & Refund – Automates challans, bills, deductions, and deposits for accurate and traceable transactions
              .
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-3 border-top"><b className="text-dark">Hon. Ajit Pawar</b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> Deputy Chief Minister of Maharashtra</cite>
          </footer>
        </blockquote>
      </div>


      <div className="col-12 col-md-6 col-lg-5 mt-5 mx-auto">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          <iframe width="100%" height="300" src="https://www.youtube.com/embed/9MHZGzoFguw?si=Pd9ullk5mz7MU8iX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" Raigad Samadhan " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Raigad Samadhan is an online portal and mobile application launched by the Raigad District Police.
              It was inaugurated on 10th March 2025 by Mr. Sanjay Darade, Special Inspector General of Police, Konkan Range.
              The main objective of this initiative is to ensure quick, transparent, and effective resolution of industrial sector complaints, and to create a safe and industry-friendly environment in Raigad district for entrepreneurs to conduct their businesses without fear.
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-3 border-top"><b className="text-dark">Hon. Somnath Gharge</b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> SP Raigad </cite>
          </footer>
        </blockquote>
      </div>


      {/* <div className="col-12 col-md-6 col-lg-5 mt-5 mx-auto">
        <blockquote className="blockquote blockquote-custom bg-white py-5 px-3 shadow2 rounded">

          <video width="100%" height="300px" poster="Assets/Images/video/nagpur-01.PNG" controls>
            <source src="Assets/Images/video/nmc.mp4" type="video/mp4" />
          </video>

          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="mb-0 mt-2 font-italic fs-6 pt-3" style={{ textAlign: 'justify' }}>"Under tight deadlines and with high expectations, CDAT has delivered
            the Public Grievance Management System both Mobile App and Web Application suited to the requirement of
            Urban Local Body , The Citizens of City have given a overwhelming reponse , The app has seen 30k plus
            downloads and still counting in very short time , Well Done Team CDAT".</p>
          <footer className="blockquote-footer pt-4 mt-5 border-top"><b className="text-dark">Commissioner</b>
            <cite title="Source Title"> Nagpur Municipal Corporation</cite>
          </footer>
        </blockquote>
      </div> */}

      <div className="col-12 col-md-6 col-lg-5 mt-5 mx-auto fixed-card">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          {/* Optional video (remove if text-only review) */}
          <video
            width="100%"
            height="300px"
            poster="Assets/Images/video/nagpur-01.PNG"
            controls
          >
            <source src="Assets/Images/video/nmc.mp4" type="video/mp4" />
          </video>

          <div className="blockquote-custom-icon bg-golden shadow-sm">
            <i className="fa fa-quote-left text-white"></i>
          </div>

          <p
            className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}
          >
            <span style={{ fontWeight: 'bold' }}>" Public Grievance Management System " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Under tight deadlines and with high expectations, CDAT has delivered
              the Public Grievance Management System both Mobile App and Web
              Application suited to the requirement of Urban Local Body , The
              Citizens of City have given a overwhelming reponse , The app has seen
              30k plus downloads and still counting in very short time , Well Done
              Team CDAT.
            </ShowMoreText>
          </p>
          <footer className="blockquote-footer pt-4 mt-lg-3 border-top">
            <b className="text-dark">Hon. Tukaram Mundhe </b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> Commissioner of NMC</cite>
          </footer>
        </blockquote>
      </div>



      <div className="col-12 col-md-6 col-lg-5 mt-5 mx-auto">

        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          <iframe width="100%" height="300px" src="https://www.youtube.com/embed/pW0OdIeWrbk"
            title="Ahmednagar पोलिसांची नागरिकांसाठी &#39;ई-टपाल&#39; प्रणाली, पोलीस अधीक्षक Manoj Patil यांची संकल्पना |Police"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>

          <div className="blockquote-custom-icon bg-golden shadow-sm "><i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" ई - टपाल " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Police Department is a internet & intranet base solution for all government functionaries to monitor their Daily Branch, Section and Table wise letter and file movement of their own Office. LFMS is helping for electronic letter inwards, letter movement from one desk to another desk, creation of desk wise files and letter draft for approval, dispatch of letters, desk wise setting due dates and reminders, desk wise queries and report and migration of letters and files from one desk to another desk.
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-lg-3 border-top"><b className="text-dark">Hon. Manoj Patil </b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> SP Ahmednagar</cite>
          </footer>

        </blockquote>

      </div>

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3  shadow2 rounded">
          <video width="100%" height="300px" poster="Assets/Images/video/cm-01.jpg" controls>
            <source src="Assets/Images/video/amchi mulgi.mp4" type="video/mp4" />
          </video>
          <div className="blockquote-custom-icon bg-golden shadow-sm">
            <i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" AMCHI MULGI - PUBLIC GRIEVANCE" </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Project of the State Health Department has been successfully inaugurated by the Hon. Chief Minister, Maharashtra State.
              The software under the PCPNTD Act – "AMCHI MULGI." This software aims to create a public portal for managing  grievances under the PCPNDT Act, contributing to the state's efforts to address gender-based inequalities
              and promote equity.
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-lg-3  border-top">
            <b className="text-dark">Hon. Eknath Shinde</b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> Chief Minister Maharashtra</cite>
          </footer>
        </blockquote>
        {/* <!-- END --> */}
      </div>

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">

          <img src="Assets/Images/video/nhm.jpg" alt="" width="100%" height="300px" />


          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className={`mb-0 mt-2 font-italic fs-6 pt-3 `}
            style={{ textAlign: "justify" }}>
            <span style={{ fontWeight: 'bold' }}>" Nursing Home Registration " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Project of the Public Health Department Govt. of Maharashtra has been successfully inaugurated by the Hon. Chief Minister, Maharashtra State. The Nursing Home Registration application is designed to facilitate the registration process for nursing homes under the Bombay Nursing Home Registration Act of 1949 and the Maharashtra Nursing Home Registration (Amendment) Regulation Rules, the application allows applicants to request new licenses, as well as renew existing licenses for clinical establishments for nursing homes.
              The system allows applicants to submit detailed information, track application status through various approval stages, and access role-specific dashboards. It also features area-based routing, automatically directing applications to the appropriate inspection officer based on the region type (e.g., Municipal Council, Corporation, Rural, or Cantonment).
            </ShowMoreText>
          </p>

          <footer className="blockquote-footer pt-4 mt-lg-3 border-top">
            <b className="text-dark">Hon. Eknath Shinde</b>
            <cite title="Source Title" style={{ fontSize: '16px' }}> Chief Minister Maharashtra</cite>
          </footer>
        </blockquote>
        {/* <!-- END --> */}
      </div>


      {/* <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">
          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="mb-0 mt-2 font-italic pt-3 fs-6 mb-5" style={{ textAlign: 'justify' }}>The Pension Management system by CDAT was really the need of the Hour, Thanks
            Team CDAT, The pensioners of Zilla Parishad are truly benefited by this system,
            It has brought complete transparency and efficiency in the pension sanction and
            disbursement process of Zilla Parishad.</p>
          <footer className="blockquote-footer pt-4 mt-4 border-top "><b className="text-dark">Dy CAFO</b>
            <cite title="Source Title"> Zilla Parishad</cite>
          </footer>
        </blockquote>
      </div> */}

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">
        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">
          <img src="Assets/Images/video/lfmsPhoto.png" alt="" width="100%" height="300px" />

          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="mb-0 mt-2 font-italic fs-6 pt-3" style={{ textAlign: 'justify' }}>
            <span style={{ fontWeight: 'bold' }}>" Letter and File Management System " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              Designed and Developed by CDAT
              has really brought transparency in the Government Domain , The software is very light , easy to operate with
              interactive dashboards, CDAT is a company who understands the government domain, Their expertise empower the
              digital transformation in Government Offices smoothly and efficiently, Good Job Team CDAT.
            </ShowMoreText>
          </p>
          <footer className="blockquote-footer pt-4 mt-3 border-top"><b className="text-dark">Project Director</b>
            <cite title="Source Title " style={{ fontSize: '16px' }}> State Agriculture Department </cite>
          </footer>
        </blockquote>

      </div>

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">

        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">
          <img src="Assets/Images/video/SunrichAgroPhoto.png" alt="" width="100%" height="300px" />
          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="mb-0 mt-2 font-italic fs-6 pt-3" style={{ textAlign: 'justify' }}>
            <span style={{ fontWeight: 'bold' }}>" Sunrich Agro Industries " </span>
            <ShowMoreText
              lines={4}
              more="Show more"
              less="Show less"
              anchorClass="read-more"
              anchorStyle={{ color: 'blue', cursor: 'pointer' }}
            >
              We have taken CDAT Pune's Fertilizer Manufacturing Company ERP software. This software is very beneficial for the company. We can manage the entire company on this one software. This software helped us a lot for our company development. It helped us to track and monitor our employee's work in very efficient way. Thank you...!!
            </ShowMoreText>
          </p>
          <footer className="blockquote-footer pt-4 mt-4 border-top"><b className="text-dark">Ravindra Narsale</b>
            <cite title="Source Title " style={{ fontSize: '16px' }}> Sunrich Agro Industries </cite>
          </footer>

        </blockquote>

      </div>

      <div className="col-12 col-md-6 col-lg-5 mx-auto mt-5">

        <blockquote className="blockquote blockquote-custom bg-white pt-5 pb-4 px-3 shadow2 rounded">
          <img src="Assets/Images/video/milsoPhoto.png" alt="" width="100%" height="300px" />

          <div className="blockquote-custom-icon bg-golden shadow-sm"><i className="fa fa-quote-left text-white"></i></div>
          <p className="pb-lg-2 mt-2 font-italic fs-6 pt-3" style={{ textAlign: 'justify' }}>
            <span style={{ fontWeight: 'bold' }}>" MILSO " </span> <br />
            Dealing with the team was a pleasant experience. The "MILSO" website launches smoothly because of the CDAT team members' prompt responses, communication, and co-operation. Thank you.
          </p>
          <footer className="blockquote-footer pt-4 mt-3 border-top"><b className="text-dark"> Director</b>
            <cite title="Source Title " style={{ fontSize: '16px' }} > MILSO</cite>
          </footer>

        </blockquote>

      </div>
    </div>
  )
}